import RequiredProfileForm from './RequiredProfileForm';

export default RequiredProfileForm;


// WEBPACK FOOTER //
// ./src/components/forms/RequiredProfileForm/index.js